// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2hlFr","link":"styles_link__xk7rK","img":"styles_img__3c_M7"};